import { render } from "./message-box.md?vue&type=template&id=673fa6c6"
import script from "./message-box.md?vue&type=script&lang=js"
export * from "./message-box.md?vue&type=script&lang=js"
script.render = render

export default script